import {faChevronDown} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Icon, Trigger, Value} from '@radix-ui/react-select';
import clsx from 'clsx';

type Props = React.ComponentPropsWithRef<typeof Trigger> &
  Pick<React.ComponentProps<typeof Value>, 'placeholder'>;
export const SelectTrigger = ({
  ref: forwardedRef,
  className,
  placeholder,
  ...props
}: Props & {
  ref?: React.RefObject<HTMLButtonElement>;
}) => {
  return (
    <Trigger
      {...props}
      ref={forwardedRef}
      className={clsx(
        'relative w-full max-w-md cursor-default rounded-md bg-slate1 py-1.5 pl-3 pr-10 text-left shadow-xs ring-1 ring-inset ring-slate7 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue8 radix-disabled:bg-slate3 sm:text-sm/6',
        className
      )}
    >
      <Value placeholder={placeholder} />

      <Icon className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
        <FontAwesomeIcon
          icon={faChevronDown}
          className="h-3 w-3 text-slate12"
          aria-hidden="true"
        />
      </Icon>
    </Trigger>
  );
};

SelectTrigger.displayName = 'SelectTrigger';
